import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { faCheckCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import './styles.scss';

class SuccessToast extends Component {
  componentDidMount() {
    setTimeout(() => {
      this.props.dismissToast();
    }, 3000);
  }
  render() {
    let { message = '', dismissToast = () => { console.log('Function Called') } } = this.props;
    return (
      <div className="success-toast-container">
        <div className="success-toast-wrapper">
          <div className="icon-text">
            <FontAwesomeIcon icon={faCheckCircle} color={'#18181A'} />
            <p className="toast-message">{message}</p>
          </div>
          <FontAwesomeIcon icon={faTimes} color={'#18181A'} onClick={dismissToast} />
        </div>
      </div>
    );
  }
}

export default SuccessToast;